(function () {
	'use strict';
	$(document).ready(function () {

		document.querySelectorAll('.tiles-list-swiper').forEach((tilesListElement) => {
			const parent = tilesListElement.parentElement;
			new Swiper(tilesListElement, {
				slidesPerView: 1,
				spaceBetween: 35,
				navigation: {
					prevEl: parent.querySelector('.swiper-button-prev'),
					nextEl: parent.querySelector('.swiper-button-next'),
				},
				breakpoints: {
					992: {
						slidesPerView: 3,
					},
					768: {
						slidesPerView: 2,
					},
				},
				watchSlidesProgress: true,
				on: {
					init: function () {
						this.update();
					},
					breakpoint: function () {
						this.update();
					}
				}
			});
		});

		$('.question-name').on("click", function () {
			$(this).toggleClass('active');
			$(this).siblings('.question-answer').slideToggle();
		})

		$('main.homepage #working-area-tags').on('select2:selecting', function (event) {
			document.querySelector('.homepage .innovations-base form input[name="search-type"]').value = event.target.value ? 'simple' : 'advanced';
		})

	});
}(jQuery));
